import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1127b0c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setup" }
const _hoisted_2 = { class: "preview-cards" }
const _hoisted_3 = { class: "preview-card-inner" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-card-back" }, null, -1))
const _hoisted_5 = { class: "preview-card-front" }
const _hoisted_6 = { class: "preview-card-inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preview-card-back" }, null, -1))
const _hoisted_8 = { class: "preview-card-front preview-info-front" }
const _hoisted_9 = { class: "preview-name" }
const _hoisted_10 = { class: "preview-info-middle" }
const _hoisted_11 = { class: "preview-text" }
const _hoisted_12 = { class: "preview-footer" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "setup-tagline" }, [
  /*#__PURE__*/_createTextVNode("Stack up matches while learning fun facts"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("about your ancestors.")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "setup-invite" }, "Choose team names", -1))
const _hoisted_15 = { class: "setup-teams" }

import { computed, onMounted, onUnmounted, ref } from 'vue'
import { MatchingCardPair } from './MatchingGameDefinition'
import MatchingImageCard from './MatchingImageCard.vue'
import TeamColorPicker from '../TeamColorPicker.vue'
import * as sounds from './GameSounds'
import { getAncestorRelationText } from '@/rd/RelationPath'
import { Gender } from '@/rd/ResearchDataModel'

type SetupStep = 'intro' | 'teams'


export default /*#__PURE__*/_defineComponent({
  __name: 'MatchingGameSetup',
  props: {
    teams: {},
    colors: {},
    names: {},
    firstPair: {},
    firstImageSrc: {}
  },
  emits: ["update:color", "update:name", "start"],
  setup(__props: any, { emit }) {

const props = __props;





const stepRef = ref<SetupStep>('intro')
const imageFlippedRef = ref(false)
const infoFlippedRef = ref(false)
const pickerOpenRef = ref<number | null>(null)
// once true (~1s after the info card flips up) the relationship squares get a red highlight box
// and the "Kent's <relationship>" caption fades in
const showKeyRef = ref(false)

let flipTimer1 = 0
let flipTimer2 = 0
let keyTimer = 0

onMounted(() => {
  flipTimer1 = window.setTimeout(() => {
    sounds.cardReveal()
    imageFlippedRef.value = true
  }, 1000)
  flipTimer2 = window.setTimeout(() => {
    sounds.cardReveal()
    infoFlippedRef.value = true
  }, 1500)
  // a beat after the second card flips, highlight the relationship key and reveal the caption
  keyTimer = window.setTimeout(() => { showKeyRef.value = true }, 3500)
})

onUnmounted(() => {
  window.clearTimeout(flipTimer1)
  window.clearTimeout(flipTimer2)
  window.clearTimeout(keyTimer)
})

const relationshipStepsRef = computed(() =>
  [...(props.firstPair.relationship || '')].map(s => s === 'F' ? 'f' : 'm'))

// the ancestor relationship word (e.g. "grandfather"), built from the F/M path. The first square is
// the root person (Kent) in the root couple, so generations-up = length - 1 (e.g. "FF" = Kent's
// father, "FFF" = Kent's grandfather); the final square gives the ancestor's gender. Reuses the
// shared builder.
const relationTextRef = computed(() => {
  const rel = props.firstPair.relationship || ''
  const generations = rel.length - 1
  if (generations < 1) return ''
  const gender = rel.at(-1) === 'F' ? Gender.Male : Gender.Female
  return getAncestorRelationText(generations, gender)
})

function togglePicker(teamId: number) {
  pickerOpenRef.value = pickerOpenRef.value === teamId ? null : teamId
}

function emitStart() {
  emit('start')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (stepRef.value === 'intro')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["preview-card", { 'is-up': imageFlippedRef.value }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(MatchingImageCard, {
                    src: _ctx.firstImageSrc,
                    focal: _ctx.firstPair.images[0],
                    relationship: _ctx.firstPair.relationship,
                    alt: _ctx.firstPair.name,
                    "highlight-relationship": showKeyRef.value
                  }, null, 8, ["src", "focal", "relationship", "alt", "highlight-relationship"])
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["preview-card", { 'is-up': infoFlippedRef.value }])
            }, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.firstPair.name), 1),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.firstPair.text), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["rel-key", { 'rel-key-highlight': showKeyRef.value }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationshipStepsRef.value, (relStep, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: i,
                          class: _normalizeClass(["rel-square", relStep])
                        }, null, 2))
                      }), 128))
                    ], 2)
                  ])
                ])
              ])
            ], 2)
          ]),
          _createElementVNode("p", {
            class: _normalizeClass(["relation-caption", { visible: showKeyRef.value }])
          }, "Kent's " + _toDisplayString(relationTextRef.value), 3),
          _hoisted_13,
          _createElementVNode("button", {
            class: "btn btn-primary btn-lg",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (stepRef.value = 'teams'))
          }, "Get started")
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team, i) => {
              return (_openBlock(), _createBlock(TeamColorPicker, {
                key: team.id,
                color: _ctx.colors[team.id],
                name: _ctx.names[team.id],
                open: pickerOpenRef.value === team.id,
                "hint-delay": i * 180,
                onToggle: ($event: any) => (togglePicker(team.id)),
                "onUpdate:color": ($event: any) => (emit('update:color', team.id, $event)),
                "onUpdate:name": ($event: any) => (emit('update:name', team.id, $event))
              }, null, 8, ["color", "name", "open", "hint-delay", "onToggle", "onUpdate:color", "onUpdate:name"]))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary btn-lg",
            onClick: emitStart
          }, "Start game")
        ], 64))
  ]))
}
}

})